import React, { PropsWithChildren } from 'react';

type KeywordsListContainerProps = {
  ariaLabel?: string; // only required when user actively adds keywords
};

export function KeywordsListContainer({ ariaLabel, children }: PropsWithChildren<KeywordsListContainerProps>) {
  return (
    <ul className="keywords" aria-label={ariaLabel}>
      {React.Children.map(children, child => (
        <li className="keywords__item">
          <span className="keywords__tag">{child}</span>
        </li>
      ))}
    </ul>
  );
}
